import { ApiManager } from "../../core/api-manager";
import { DataManager } from "../../core/data-manager";
import { settings } from "../../config/settings";
import { LanguageProvider } from "../../core/language-provider";
import { requestErrorToast, requestSuccessToast } from "../../utils/toast";

export function onUpdate(response, entity, data, id) {}
